import { render, staticRenderFns } from "./HaulageCapacityPage.vue?vue&type=template&id=61ab515a&scoped=true&"
import script from "./HaulageCapacityPage.vue?vue&type=script&lang=js&"
export * from "./HaulageCapacityPage.vue?vue&type=script&lang=js&"
import style0 from "./HaulageCapacityPage.vue?vue&type=style&index=0&id=61ab515a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ab515a",
  null
  
)

export default component.exports